export const ConnectJournalConstants = {
  GET_CONNECT_JOURNAL_GLOBAL_REQUEST: 'CONNECT_JOURNAL/GET_CONNECT_JOURNAL_GLOBAL_REQUEST',
  GET_CONNECT_JOURNAL_GLOBAL_SUCCESS: 'CONNECT_JOURNAL/GET_CONNECT_JOURNAL_GLOBAL_SUCCESS',
  GET_CONNECT_JOURNAL_GLOBAL_ERROR: 'CONNECT_JOURNAL/GET_CONNECT_JOURNAL_GLOBAL_ERROR',
  GET_CONNECT_JOURNAL_WORKSPACE_REQUEST: 'CONNECT_JOURNAL/GET_CONNECT_JOURNAL_WORKSPACE_REQUEST',
  GET_CONNECT_JOURNAL_WORKSPACE_SUCCESS: 'CONNECT_JOURNAL/GET_CONNECT_JOURNAL_WORKSPACE_SUCCESS',
  GET_CONNECT_JOURNAL_WORKSPACE_ERROR: 'CONNECT_JOURNAL/GET_CONNECT_JOURNAL_WORKSPACE_ERROR'
};
